import { select, call, put, all } from 'redux-saga/effects';
import { isNumber } from '@bitComponents/utils/common';
import { getCustomerInfo } from '@gcloud-npm/adabyron.abs-layer.client.customer-info'
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { actions as apisNeedsActions } from '../reducers/apisNeeds';
import { actions as manualActions } from '../reducers/manual';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { getByName } from './customizer';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { INFO_BLOCKS } from '../utils/manual';
import { commonActions } from '../reducers/common';
import { MANUAL_PRODUCT_TYPES_MAPPING, PRODUCT_TYPES } from '../utils/catalog';
import { getEmployeesProducts } from '../bitSagas/employees';
import { CQ_POTS, IVA } from '../catalogConstants';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import { getProductOfferingOrion } from '../bitSagas/getProductOffering';
import { FLOW_TYPES } from '../flowDefinition/flowTypes';
import { getR2RCompatibility } from '../bitSagas/getR2RCompatibility';
import LocalStorageLib from '@gcloud-npm/utils.secure.local-storage';
import { initCQ } from '../sagas/ascertain';
import { getRisk } from '../sagas/risk';
import { genericSendToSEMessage } from '../sagas/se';

const productTypeTranslation = {
  [PRODUCT_TYPES.MOBILE]: 'móvil',
  [PRODUCT_TYPES.LAND_LINE]: 'fija',
}

// A selector function that retrieves the apiNeeds state from the store
const apisNeedsStore = state => state.apiNeeds;
const offerStore = state => state.offer;
const manualStore = state => state.manual;
const contextStore = state => state.context.data;
const getErrorManagement = state => state.errorManagement;
const flowStore = state => state.flow;

export function* getProductTypes(input) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  try {
    // The name of the activity for which we are retrieving product types
    const CREATIVITY_NAME = 'TELCO_Manual_ProductTypes';
    // Parameters for the `getByName` function call
    const getByNameParams = {
      ...input,
      name: CREATIVITY_NAME,
      custoType: 'creativity',
    };

    // Makes an API request to retrieve data using the `getByName` function
    const response = yield call(getByName, getByNameParams);

    const { productTypes } = response;

    if (productTypes) {
      yield put(manualActions.setProductTypes(productTypes))
      return megaMinderStatus.OK;
    }

    return {
      ...megaMinderStatus.KO,
      errorInfo: 'productTypes no se ha podido recuperar de custo'
    };
  } catch (e) {
    console.log(e);
    return null;
  }
}

const getMainProductOptions = (optionLines, productType, key, allowMigration = true, onlyMigration = false, phoneLine = null) => {
  const mainOptionsForUI = {
    options: [
      {
        actionId: '15',
        description: `Línea ${productTypeTranslation[productType]}`,
        productOfferingName: '',
        cqsiId: `${key}XXX`
      },
      {
        actionId: '1',
        description: `Línea ${productTypeTranslation[productType]}`,
        productOfferingName: '',
        cqsiId: `${key}XXXX`
      },
    ],
    thereIsPortability: true,
    mainOptionSelected: null
  };

  let mainOptions = [
    {
      actionId: '15',
      clientPhoneNumberToBeAppliedTo: null,
      cqsiId: '10001',
      description: `Línea ${productTypeTranslation[productType]}`,
      productType,
    },
    {
      actionId: '1',
      clientPhoneNumberToBeAppliedTo: null,
      cqsiId: '10002',
      description: `Línea ${productTypeTranslation[productType]}`,
      productType,
    },
  ];
  if(allowMigration){
    if (onlyMigration) {
      mainOptions = [];
      mainOptionsForUI.options = [];
      mainOptionsForUI.mainOptionSelected = '11';
    }
  
    if (optionLines && optionLines.length > 0) { 
      const migraOptions = {
        actionId: '11',
        phoneOptions: [],
        description: `Línea ${productTypeTranslation[productType]}`,
        productOfferingName: ''
      };
  
      let i = 0;
      if(onlyMigration && phoneLine) {
        const { number } = phoneLine;
        migraOptions.phoneOptions.push({
            label: number,
            value: number
        });
  
        const mainOption = {
          actionId: '11',
          clientPhoneNumberToBeAppliedTo: number,
          cqsiId: `2000${i}`,
          description: `Línea ${productTypeTranslation[productType]}`,
          productType,
        };
  
        mainOptions.push(mainOption);
      } else {
        optionLines.forEach(line => {
          const { number } = line;
          migraOptions.phoneOptions.push({
              label: number,
              value: number
          });
    
          const mainOption = {
            actionId: '11',
            clientPhoneNumberToBeAppliedTo: number,
            cqsiId: `2000${i}`,
            description: `Línea ${productTypeTranslation[productType]}`,
            productType,
          };
    
          mainOptions.push(mainOption);
          i += 1;
        });
      }
      
      mainOptionsForUI.options.push(migraOptions);
    }
  }

  return {
    mainOptions,
    mainOptionsForUI,
  }
}

const getSecondaryProductOptions = (optionLines, productType, numLines, key) => {
  // customerQuoteItems --> secondaryOptions
  const secondaryOptionsForApi = [
    {
      cqsiId: '268982',
      actionId: '1',
      clientPhoneNumberToBeAppliedTo: null,
      productOffering: {
        id: '2758',
        productPromotions: [],
        maintainedPromotions: [],
        clientPromotionsToEnd: []
      }
    },
    {
      cqsiId: '269186',
      actionId: '15',
      clientPhoneNumberToBeAppliedTo: null,
      productOffering: {
        id: '2758',
        productPromotions: [],
        maintainedPromotions: [],
        clientPromotionsToEnd: []
      }
    },
  ];

  const secondaryOptionsForUI = [
    {
      actionId: '15',
      description: `Línea ${productTypeTranslation[PRODUCT_TYPES.MOBILE]}`,
      productOfferingName: 'Línea móvil Ilimitada 50 GB',
      cqsiId: '269186'
    },
    {
      actionId: '1',
      description: `Línea ${productTypeTranslation[PRODUCT_TYPES.MOBILE]}`,
      productOfferingName: 'Línea móvil Ilimitada 50 GB',
      cqsiId: '268982'
    }
  ];

  if (optionLines && optionLines.length > 0) { 
    const migraSecondaryOptionsForUI = {
      actionId: '11',
      phoneOptions: [],
      description: `Línea ${productTypeTranslation[PRODUCT_TYPES.MOBILE]}`,
      productOfferingName: ''
    };

    let i = 0;
    optionLines.forEach(line => {
      const { number } = line;
      migraSecondaryOptionsForUI.phoneOptions.push({
          label: number,
          value: number
      });

      const secondaryOptionForApi = {
        actionId: '11',
        clientPhoneNumberToBeAppliedTo: number,
        cqsiId: `3000${i}`,
        description: `Línea ${productTypeTranslation[PRODUCT_TYPES.MOBILE]}`,
        productType: PRODUCT_TYPES.MOBILE
      };

      secondaryOptionsForApi.push(secondaryOptionForApi);

      i += 1;
    });

    secondaryOptionsForUI.push(migraSecondaryOptionsForUI);
  }

  const choiceGroups = [];

  for (let i = 0; i < numLines; i += 1) {
    choiceGroups.push({
      customerQuoteItems: secondaryOptionsForApi,
      id: '6',
      canBeUnselectable: false
    })
  }


  const secondaryProductOptions = {
    MOBILE: {
      choiceGroups,
      parentActionId: '11'
    }
  };

  const choiceGroupsForUI = [];
  for (let i = 0; i < numLines; i += 1) {
    const secondaryOptionsForUIToAdd = JSON.parse(JSON.stringify(secondaryOptionsForUI));

    const lineNumber = i+1;
    secondaryOptionsForUIToAdd.forEach(secondaryOptionForUI => {
      secondaryOptionForUI.description = `${lineNumber}ª línea móvil`;
    })

    choiceGroupsForUI.push({
      customerQuoteItems: secondaryOptionsForUIToAdd,
      id: '6',
      canBeUnselectable: false
    })
  }


  const secondaryProductOptionsForUI = {
    MOBILE: {
      '11': {
        choiceGroups: choiceGroupsForUI,
        keepGroups: []
      },
      '15': {
        choiceGroups: choiceGroupsForUI,
        keepGroups: []
      },
      '1': {
        choiceGroups: choiceGroupsForUI,
        keepGroups: []
      }
    }
  }

  return {
    secondaryProductOptions,
    secondaryProductOptionsForUI,
  }
}

const goToNonIncludedFlow = (notIncludedFlowUrl) => {
  window.location.href = notIncludedFlowUrl;
}

export function* getProductsInfo({ showError, normalizeHttpErrors }) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(
    loaderControlActions.setLoaderState({
      loading: true,
    })
  );

  const offerInfo = yield select(offerStore);
  const manualInfo = yield select(manualStore);
  const { myProductsInfo } = yield select(apisNeedsStore);
  const { flowJson } = yield select(flowStore);

  const { alias, modality } = offerInfo;
  const { productTypes } = manualInfo;

  if (modality === 'included' && flowJson?.includedOnlyForModule) {
    const localStorageLib = new LocalStorageLib();
    const secure = localStorageLib.getItem("ts");

    if (secure?.userPo?.PACK_MODULES) {
      const modulesStr = secure.userPo.PACK_MODULES.split('||');

      const isIncluded = modulesStr.some(item =>
        flowJson.includedOnlyForModule.some(valor => item.includes(valor))
      );

      if (!isIncluded) {
        goToNonIncludedFlow(flowJson.notIncludedFlowUrl);
        return null;
      }
    } else {
      goToNonIncludedFlow(flowJson.notIncludedFlowUrl);
      return null;
    }
  }


  try {
    // Parameters for the `getByName` function call
    const getProductOfferingOrionParams = {
      alias,
      normalizeHttpErrors,
      showError,
    };

    // Makes an API request to retrieve data using the `getByName` function
    const productOfferingData = yield call(
      getProductOfferingOrion,
      getProductOfferingOrionParams
    );

    
    if (!productOfferingData?.name) {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: "getProductsInfo",
        context,
        filePath: "sagas/manual",
      });
      frontSonda.fatalMessage({
        info: `No se encuentra el producto ${alias} en Orion`,
        error: null,
      });
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: "Producto no encontrado",
      };
    }

    const { productOffering, name, pricesInfo, provisionalAgreementUrl } = productOfferingData;
    
    if (provisionalAgreementUrl) {
      const provisionalAgreementUrlAttachments= [{
        url: provisionalAgreementUrl,
      }]
      yield put(
        uiNeedsActions.setProvisionalAgreementData({ agreementApplies: true, attachments: provisionalAgreementUrlAttachments })
      );
    }

    const productBlocks = productTypes[flowJson.flowName].steps;

    if (productBlocks.indexOf(INFO_BLOCKS.Mobile) !== -1) {
      let mobileLines = [];
      if (myProductsInfo?.linesMobile) {
        mobileLines = myProductsInfo?.linesMobile;
      }

      const { mainOptions, mainOptionsForUI } = getMainProductOptions(
        mobileLines,
        PRODUCT_TYPES.MOBILE,
        "MOB",
        false,
      );

      yield put(
        commonActions.setSelectElementsNeeds({
          cqId: "XXX",
          mainOptions,
          mainOptionsForUI,
          mainOptionSelected: null,
          productType: PRODUCT_TYPES.MOBILE,
          productOffering,
        })
      );
    }

    if (productBlocks.indexOf(INFO_BLOCKS.SelectLine) !== -1) {
      if (myProductsInfo?.linesMobile?.length >= 1) {
        const phoneOptions = [];
        myProductsInfo?.linesMobile.forEach((line) => {
          if (modality === 'included') {
            // Lineas de mimo
            if (line.productType === 0) {
              phoneOptions.push({
                label: line.number,
                value: line.number,
              });
            }
          } else {
            phoneOptions.push({
              label: line.number,
              value: line.number,
            });
          }
        });
        yield put(manualActions.setPhoneOptions(phoneOptions));
      } else {
        const { handledErrors } = yield select(getErrorManagement);
        yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_CLIENT_PRODUCTS));
  
        return {
          ...megaMinderStatus.KO,
          errorInfo: "Producto no contratable",
        };
      }
    }

    yield put(
      manualActions.setProductConfig({
        productBlocks,
        productInfo: {
          ...productOfferingData,
          tipo: flowJson.flowName,
        },
      })
    );

    let cart = {
      recurringCharges: {
        products: [
          {
            productOffering: {
              // id: productOffering,
              text: name,
            },
            promotionId: null,
            promotionText: pricesInfo.recurringCharges.promotionText || '',
            priceBeforeDiscounts: pricesInfo.recurringCharges.priceBeforeDiscounts || '',
            finalPrice: pricesInfo.recurringCharges.finalPrice,
            unity: pricesInfo.recurringCharges.priceUnit,
            taxName: IVA,
            productType: MANUAL_PRODUCT_TYPES_MAPPING[flowJson.flowName],
          },
        ],
        groupPriceBeforeDiscounts: pricesInfo.recurringCharges.priceBeforeDiscounts || '',
        groupPrice: pricesInfo.recurringCharges.finalPrice,
        unity: pricesInfo.recurringCharges.priceUnit,
      },
      oneTimeCharges: {},
      taxName: IVA,
      termsAndConditions: "",
    };
    if(isNumber(pricesInfo?.oneTimeCharges?.finalPrice)){
      cart.oneTimeCharges = {
        products: [
          {
            productOffering: {
              id: productOffering,
              text: flowJson.flowName === FLOW_TYPES.PREPAID ? 'Saldo inicial tarjeta prepago' : 'Cuota de alta',
            },
            promotionId: null,
            promotionText: '',
            priceBeforeDiscounts: null,
            finalPrice: pricesInfo.oneTimeCharges.finalPrice,
            portabilityFinalPrice: 0,
            taxName: IVA,
            productType: MANUAL_PRODUCT_TYPES_MAPPING[flowJson.flowName],
          }
        ],
        groupPrice: pricesInfo.oneTimeCharges.finalPrice,
        portabilityGroupPrice: 0,
      };
    }

    yield put(uiNeedsActions.setPricesInfo(cart));
    if(flowJson.flowName !== FLOW_TYPES.PREPAID){
      yield put(commonActions.setPoptSelected({ id: CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID }));
    }

    return megaMinderStatus.OK;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export function* getEmployeesProductsInfo(input) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  const offerInfo = yield select(offerStore);
  const { productOffering, netflixObj } = offerInfo;

  const manualInfo = yield select(manualStore);

  const { productTypes } = manualInfo;

  const { myProductsInfo } = yield select(apisNeedsStore);

  try {
    // Parameters for the `getByName` function call
    const { showError } = input;
    const params = {
      ...input,
      reduxUpdate: {},
    };

    // Makes an API request to retrieve data using the `getByName` function
    const response = yield call(getEmployeesProducts, params);

    let productsSelected = response.filter(product => product.idPo.toString() === productOffering);
    let productSelected = null;
    
    if (productsSelected && productsSelected.length > 0) {
      if (netflixObj?.productOffering && netflixObj?.mode) {
        const netflixParam = `${netflixObj.productOffering}_${netflixObj.mode}`;
        productsSelected = productsSelected.filter(product => product.idPoN === netflixParam);
      }
      const currentUrl = new URL(window.location.href);
      const { searchParams } = currentUrl;
      const poTVParam = searchParams.get("poTV");
      if(poTVParam) {
        productsSelected = productsSelected.filter(product => product.idPoTv === poTVParam);
      }

      productSelected = productsSelected[0];
    }

    if (!productSelected) {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: 'getEmployeesProductsInfo',
        context,
        filePath: 'sagas/manual',
      });
      frontSonda.fatalMessage({ info: 'No se encuentra el producto de empleados a contratar entre los posibles', error: null });
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: 'Producto no encontrado',
      }
    }

    if (productSelected.pdf) {
      const provisionalAgreementUrlAttachments= [{
        url: productSelected.pdf,
      }]
      yield put(
        uiNeedsActions.setProvisionalAgreementData({ agreementApplies: true, attachments: provisionalAgreementUrlAttachments })
      );
    }

    const {
      tipo: productType,
      lineas: numLines,
      descripcion: productName,
      pvp: productPrice,
      descuento: discount,
      idPo,
    } = productSelected;

    const productBlocks = productTypes[productType].steps;

    if (productBlocks.indexOf(INFO_BLOCKS.Mobile) !== -1) {
      let mobileLines = [];
      if (myProductsInfo?.linesMobile) {
        mobileLines = myProductsInfo?.linesMobile;
      }

      const { mainOptions, mainOptionsForUI } = getMainProductOptions(mobileLines, PRODUCT_TYPES.MOBILE ,'MOB')

      yield put(commonActions.setSelectElementsNeeds({
        cqId: "XXX",
        mainOptions,
        mainOptionsForUI,
        mainOptionSelected: null,
        productType: PRODUCT_TYPES.MOBILE,
        productOffering,
      }))
    }

    if (productBlocks.indexOf(INFO_BLOCKS.Landline) !== -1) {
      let phoneLines = [];
      if (myProductsInfo?.linesPhone) {
        phoneLines = myProductsInfo?.linesPhone;
      }
      
      const packPhoneLine = phoneLines.find(line => line.isPack === true);

      let onlyMigration = false;

      if (packPhoneLine && productType === 'miMovistar' ) {
        const { fullAdress, locationId } = packPhoneLine;// fullAdress viene asi mal escrito de TCOL, NO TOCAR

        yield put(commonActions.setInstallationAddress({ fullAddress: fullAdress, locationId}));
        yield put(manualActions.setNotShowAccountBlock());
        onlyMigration = true;
      }

      const { mainOptions, mainOptionsForUI } = getMainProductOptions(phoneLines, PRODUCT_TYPES.LAND_LINE ,'LDL', true, onlyMigration, packPhoneLine)

      let mainOptionSelected = '1';

      if (mainOptions.length === 1) {
        mainOptionSelected = mainOptions[0].actionId;
        yield put(manualActions.setNotShowLandLine());
      }

      let secondaryOptionsForUI = null;
      let secondaryOptions = null;
      if (productBlocks.indexOf(INFO_BLOCKS.PackMobile) !== -1) {
        let mobileLines = [];
        if (myProductsInfo?.linesMobile) {
          mobileLines = myProductsInfo?.linesMobile;
        }

        const secondaryOptionsObjs = getSecondaryProductOptions(mobileLines, PRODUCT_TYPES.MOBILE, numLines, 'PACK');
        
        secondaryOptionsForUI = secondaryOptionsObjs.secondaryProductOptionsForUI;
        secondaryOptions = secondaryOptionsObjs.secondaryProductOptions;          
      }

      yield put(commonActions.setSelectElementsNeeds({
        cqId: "XXX",
        mainOptions,
        mainOptionsForUI,
        mainOptionSelected: mainOptionSelected,
        secondaryOptions,
        secondaryOptionsForUI,
        productType: PRODUCT_TYPES.LAND_LINE,
        productOffering,
      }))
    }
    
    yield put(manualActions.setProductConfig({
      productBlocks,
      productInfo: productSelected,
    }));
    
    const cart = {
      recurringCharges: {
        products: [
          {
            productOffering: {
              id: idPo,
              text: productName
            },
            promotionId: null,
            promotionText: "",
            priceBeforeDiscounts: null,
            clientPhoneNumberToBeAppliedTo: null,
            finalPrice: productPrice,
            taxName: IVA,
            productType: MANUAL_PRODUCT_TYPES_MAPPING[productType],
          }
        ],
        groupPrice: productPrice,
        groupPriceBelow: `${discount} de descuento aplicado por ser empleado`
      },
      oneTimeCharges: {},
      taxName: IVA,
      termsAndConditions: "",
    };

    yield put(uiNeedsActions.setPricesInfo(cart));

    return megaMinderStatus.OK;
  } catch (e) {
    console.log(e);
    return null;
  }
}

const normalizeCustomerInfo = (data) => {
  let res = {
      userCompatibilities: null,
      creditLimit: null
  }
  if (data?.compatibility?.compatibilityTelcoCustomerProductInfo) {
      const compatibilities = data.compatibility.compatibilityTelcoCustomerProductInfo;
      if (typeof compatibilities === 'object') {
          //Convert first level key to minus
          const userCompatibilities = Object.keys(compatibilities).reduce((acc, key) => {
              acc[key.toLowerCase()] = compatibilities[key];
              return acc;
          }, {});
          res.userCompatibilities = userCompatibilities;
      }
  }
  if (data?.customer?.riskAssessment?.customerCreditProfile) {
      const { creditLimit, monthlyCreditLimit } = data.customer.riskAssessment.customerCreditProfile;
      res.creditLimit = {
          tpvp: creditLimit,
          mpvp: monthlyCreditLimit
      }
  }
  if (data?.customer?.campaigns?.redeemed) {
      const r2rRenewalRedeemed = data.customer.campaigns.redeemed.some((campaign)=>campaign.campaignId === 'r2r_renovacion_principal');
      if(r2rRenewalRedeemed){
        return null;
      }
  }
  return res;
}

export function* getR2RRenewalInfo({ showError, normalizeHttpErrors }){
  // Dispatches an action to set the `loading` state to `true`
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));
  
  // getCustomerInfo
  
  const offerInfo = yield select(offerStore);
  const { flowJson } = yield select(flowStore);
  const manualInfo = yield select(manualStore);
  const { myProductsInfo, deviceInfo } = yield select(apisNeedsStore);

  const { productOffering, storageId, colorId } = offerInfo;
  const { productTypes } = manualInfo;

  const localStorageLib = new LocalStorageLib();
  const secure = localStorageLib.getItem("ts");

  const context = yield select(contextStore);

  let response = null;

  try {
    response = yield call(getCustomerInfo, {context});
  } catch (e) {
    console.log(e);
  }

  const customerInfoNormalized = normalizeCustomerInfo(response);

  if(customerInfoNormalized?.userCompatibilities?.r2r?.hiredR2R){

    const { hiredR2R } = customerInfoNormalized.userCompatibilities.r2r;

    const includedR2RHired = hiredR2R.find(r2r => r2r.productOfferingType === 'TERMINAL_R2R_INCLUIDO' );
    
    if(includedR2RHired?.leasing?.isCancellable && myProductsInfo?.convergentMainPoId){
      const { leasing, productName: previousDeviceName, productOfferingId: previousDeviceProductOffering, hasMobileInsurance } = includedR2RHired;
      const { cancellationFee, endDate } = leasing;
      try {
        const params = {
          normalizeHttpErrors,
          showError,
          reduxUpdate: {
            errorUpdate: showError
          },
          idPO: myProductsInfo.convergentMainPoId,
        };
    
        const [getR2RCompatibilityResponse, getRiskResponse] = yield all([
          call(getR2RCompatibility, params),
          call(getRisk, { normalizeHttpErrors, showError })
        ])

        const date = new Date(endDate);

        // Obtener día, mes y año
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
        const year = date.getFullYear();

        // Formatear en DD/MM/AAAA
        const formattedDate = `${day}/${month}/${year}`;

        const r2rToCancelInfo = {
          previousDeviceName, 
          poId: previousDeviceProductOffering,
          cancellationFee,
          hasMobileInsurance,
          endDate: formattedDate,
        };

        yield put(commonActions.setR2RToCancelInfo(r2rToCancelInfo));
  
        let productSelected = getR2RCompatibilityResponse.rentToRentCompatibles.find(product => product.idPo === productOffering && product.idStorage === storageId && product.idColour === colorId);
    
        if (!productSelected) {
          const context = yield select(contextStore);
          const frontSonda = new FrontSonda({
            processName: 'getR2RRenewalInfo',
            context,
            filePath: 'sagas/manual',
          });
          frontSonda.fatalMessage({
            info: `No se encuentra el r2r a contratar entre los devueltos por compatibilidades para el productOffering: ${myProductsInfo.convergentMainPoId}`,
            error: null,
          });
          const { handledErrors } = yield select(getErrorManagement);
          yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));
    
          return {
            ...megaMinderStatus.KO,
            errorInfo: 'Producto no encontrado',
          }
        }
        
        const packPhoneLine = myProductsInfo.linesPhone.find(line => line.isPack === true);

        if (packPhoneLine ) {
          const { fullAdress, locationId } = packPhoneLine;// fullAdress viene asi mal escrito de TCOL, NO TOCAR
          yield put(commonActions.setAddressInfo({ fullAddress: fullAdress, locationId}));
        }
        const {
          offeringTerms,
        } = productSelected;
        if(offeringTerms.length !== 1 || (offeringTerms.length === 1 && offeringTerms[0]?.price?.length !== 1)){
          const context = yield select(contextStore);
          const frontSonda = new FrontSonda({
            processName: 'getR2RRenewalInfo',
            context,
            filePath: 'sagas/manual',
          });
          frontSonda.fatalMessage({
            info: `Vienen mas offeringTerms de los esperados en compatibilidades para el productOffering: ${myProductsInfo.convergentMainPoId}`,
            error: null,
          });
          const { handledErrors } = yield select(getErrorManagement);
          yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));
    
          return {
            ...megaMinderStatus.KO,
            errorInfo: 'Producto con mas offeringTerms de los esperados',
          }
        } else {
          const productBlocks = productTypes[flowJson.flowName].steps;
          yield put(manualActions.setProductConfig({
            productBlocks,
            productInfo: {
              ...productSelected,
              tipo: flowJson.flowName,
            },
            r2rRenewalInfo: {
              ...includedR2RHired,
            }
          }));
          if(getRiskResponse && deviceInfo?.pvpUntaxed){
            const {
              creditLimit,
              monthlyCreditLimit,
              hasDebt,
              unknownRisk,
              riskCode,
            } = getRiskResponse;

            const riskDetails = {
              clientWithoutAvailableCredit: creditLimit === 0 || creditLimit <= deviceInfo?.pvpUntaxed,
              clientWithDebt: hasDebt,
              clientWithUnknownRisk: unknownRisk,
              riskCode,
              creditLimit,
              monthlyCreditLimit,
            }
            yield put(uiNeedsActions.setClientRiskDetails(riskDetails));

          }

          let swapText = 'Cámbialo a los 24 meses';

          if (deviceInfo?.swapRenewalPeriod) {
            swapText = `Cámbialo a los ${deviceInfo.swapRenewalPeriod} meses`;
          }

          const cart = {
            recurringCharges: {
              products: [
                {
                  productOffering: {
                    id: productOffering,
                    text: deviceInfo?.name || productSelected.name
                  },
                  promotionId: null,
                  promotionText: "",
                  priceBeforeDiscounts: null,
                  clientPhoneNumberToBeAppliedTo: null,
                  finalPrice: offeringTerms[0].price[0].recurringCharges.finalPrice,
                  additionalInfo: deviceInfo?.swap ? swapText: '48 meses',
                  taxName: IVA,
                  productType: MANUAL_PRODUCT_TYPES_MAPPING[flowJson.flowName],
                }
              ],
              groupPrice: offeringTerms[0].price[0].recurringCharges.finalPrice,
            },
            oneTimeCharges: {
              products: [
                {
                  productOffering: {
                    id: previousDeviceProductOffering,
                    text: `Finalización contrato ${previousDeviceName}`,
                  },
                  promotionId: null,
                  promotionText: '',
                  priceBeforeDiscounts: null,
                  finalPrice: cancellationFee,
                  taxName: IVA,
                  productType: MANUAL_PRODUCT_TYPES_MAPPING[flowJson.flowName],
                }
              ],
              groupPrice: cancellationFee,
            },
            taxName: IVA,
            termsAndConditions: "",
          };
      
          yield put(uiNeedsActions.setPricesInfo(cart));
      
          return megaMinderStatus.OK;
        }
      } catch (e) {
        console.log(e);
        return null;
      }
    } else {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: 'getR2RRenewalInfo',
        context,
        filePath: 'sagas/manual',
      });
      frontSonda.fatalMessage({
        info: `El cliente no dispone de r2r cancelable`,
        error: null,
      });
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_CLIENT_PRODUCTS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: 'Cliente sin r2r cancelable',
      }
    }
  } else {
    const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: 'getR2RRenewalInfo',
        context,
        filePath: 'sagas/manual',
      });
      frontSonda.fatalMessage({
        info: `El cliente no dispone de r2r`,
        error: null,
      });
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_CLIENT_PRODUCTS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: 'Cliente sin r2r',
      }
  }

}

export function* getR2RAutoRenewalInfo(params) {
  const { showError, normalizeHttpErrors } = params;


  const context = yield select(contextStore);
  const { myProductsInfo } = yield select(apisNeedsStore);


  let response = null;
  try {
    response = yield call(getCustomerInfo, {context});
  } catch (e) {
    console.log(e);

    return megaMinderStatus.KO;
  }

  const customerInfoNormalized = normalizeCustomerInfo(response);

  if(customerInfoNormalized?.userCompatibilities?.r2r?.hiredR2R){

    const { hiredR2R } = customerInfoNormalized.userCompatibilities.r2r;
  
    const includedR2RHired = hiredR2R.find(r2r => r2r.productOfferingType === 'TERMINAL_R2R_INCLUIDO' );
    
    if(includedR2RHired?.leasing?.isCancellable && myProductsInfo?.convergentMainPoId){
      const { leasing, productName: previousDeviceName, productOfferingId: previousDeviceProductOffering, hasMobileInsurance } = includedR2RHired;
      const { cancellationFee, endDate } = leasing;

      const date = new Date(endDate);

      // Obtener día, mes y año
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
      const year = date.getFullYear();

      // Formatear en DD/MM/AAAA
      const formattedDate = `${day}/${month}/${year}`;

      const r2rToCancelInfo = {
        previousDeviceName, 
        poId: previousDeviceProductOffering,
        cancellationFee,
        hasMobileInsurance,
        endDate: formattedDate,
      };

      yield put(commonActions.setR2RToCancelInfo(r2rToCancelInfo));

      yield call(initCQ, params);
    } else {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: 'getR2RAutoRenewalInfo',
        context,
        filePath: 'sagas/manual',
      });
      frontSonda.fatalMessage({
        info: `El cliente no dispone de r2r cancelable`,
        error: null,
      });
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_CLIENT_PRODUCTS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: 'Cliente sin r2r cancelable',
      }
    }
  }
  
  // TODO no tiene r2r en parque
}


export function* testSendToSEMessage(params) {
  const message = yield call(genericSendToSEMessage, { error: null });
  debugger;
}